export class UploadSignature {
  public token: string;
  public url: string;
} 